import React, { useState, createContext } from "react";
import { CONTEXT } from "../constants";
// import { Loading } from "../typescript/interfaces/context";

const TherapeuticAreaContext = createContext<[string, Function]>([CONTEXT.THERAPEUTIC_AREA, () => {}]);

const TherapeuticAreaProvider = ({ children }) => {
  const [state, setState] = useState(CONTEXT.THERAPEUTIC_AREA);
  return <TherapeuticAreaContext.Provider value={[state, setState]}>{children}</TherapeuticAreaContext.Provider>;
};

export { TherapeuticAreaContext, TherapeuticAreaProvider };
